import "./styles.scss";
import { PhysiciansList } from "../../js/physicians-list";
import { PhysiciansDetails } from "../../js/physician-details";

new PhysiciansList();
new PhysiciansDetails();
